module.exports = __webpack_public_path__ + "static/media/margins.4bedced5.mp4";